import React, { useEffect, useMemo, useRef } from 'react'
import { useParticipant } from '@videosdk.live/react-sdk'
import ReactPlayer from 'react-player'
import Controls from './Controls'

export default function ParticipantView(props) {
  const micRef = useRef(null)
  const { webcamStream, micStream, webcamOn, micOn, isLocal, displayName } = useParticipant(props.participantId)

  const videoStream = useMemo(() => {
    if (webcamOn && webcamStream) {
      const mediaStream = new MediaStream()
      mediaStream.addTrack(webcamStream.track)
      return mediaStream
    }
  }, [webcamStream, webcamOn])

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream()
        mediaStream.addTrack(micStream.track)

        micRef.current.srcObject = mediaStream
        micRef.current.play().catch(error => console.error('videoElem.current.play() failed', error))
      } else {
        micRef.current.srcObject = null
      }
    }
  }, [micStream, micOn])

  return (
    <div>
      <p className="participant-name">Participant: {displayName}</p>
      <audio ref={micRef} autoPlay playsInline muted={isLocal} />
      <Controls webCamOn={webcamOn} micOn={micOn} />
      {webcamOn && (
        <ReactPlayer
          //
          playsinline // extremely crucial prop
          pip={false}
          light={false}
          controls={false}
          muted={true}
          playing={true}
          //
          url={videoStream}
          //
          height={'400px'}
          width={'400px'}
          onError={err => {
            console.log(err, 'participant video error')
          }}
        />
      )}
    </div>
  )
}
